<template>
  <div class="customer-list clearfix">
    <Search @getHeight="getHeight"
            @add="ProjectAdd()"
            @sort="sortCustomer()"
            @saveSet="saveSet"
            :tableConfig="tableConfig"
            :functionBtn="true"
            :tableName="tableName"
            :isDel="true"
            :delPara="delPara"
            :showSort="false"
            :sortPara="sortPara"
            ref="Search"
            searchName="getCustomerList">
      <template v-slot:left>
        <el-col :lg="24"
                :md="24"
                :sm="24"
                :xs="24">
          <el-form-item label="关键字"
                        prop="keyWord">
            <el-input v-model="searchForm.keyWord"
                      clearable
                      @keyup.enter.native="$refs.Search.handleSearch"
                      placeholder="请输入关键字查询"></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:center>
        <el-button size="small "
                   type="success"
                   plain
                   @click="batchState(1)"
                   icon="el-icon-edit-outline"
                   v-if="verifyPermission('Update')">批量发布计划</el-button>
        <el-button size="small "
                   type="success"
                   plain
                   @click="batchState(2)"
                   icon="el-icon-edit-outline"
                   v-if="verifyPermission('Update')">批量公共计划</el-button>
        <el-button size="mini"
                   icon="el-icon-back"
                   type="warning"
                   plain
                   v-if="verifyPermission('Update') && $route.query.needBack"
                   @click="$router.go(-1)">返回招聘报名</el-button>
      </template>
      <template v-slot:advancedQuery>
        <el-col :lg="5"
                :md="6"
                :sm="12"
                :xs="24">
          <el-form-item label="公共计划"
                        prop="isCooperation">
            <el-select v-model="searchForm.isPublic"
                       clearable
                       placeholder="请选择状态"
                       @clear="clear">
              <el-option label="是"
                         :value="true"></el-option>
              <el-option label="否"
                         :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8"
                :md="10"
                :sm="12"
                :xs="24">
          <el-form-item label="生效日期">
            <el-col :span="11">
              <el-date-picker style="width: 100%"
                              v-model="searchForm.dateTimeFrom"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择生效日期">
              </el-date-picker>
            </el-col>
            <el-col :span="2">~</el-col>

            <el-col :span="11">
              <el-date-picker style="width: 100%"
                              v-model="searchForm.dateTimeTo"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择结束日期">
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </Search>
    <div class="customer-table-list fr page">
      <MyTable @editCustomerInfo="editCustomerInfo"
               @selectionChange="selectionChange"
               :tableData="tableData"
               :tableConfig="tableConfig"
               :height="tableHeight"
               tableEmptyText="暂无数据，点击新增"
               @EmptyBtn="ProjectAdd"
               tableType="selection"
               :indexFlag="true">
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:isStop="slotData">
          <el-tag size="small"
                  type="success"
                  v-if="slotData.scope.row.projectStatus=='已发布'">已发布</el-tag>
          <el-tag size="small"
                  type="danger"
                  v-else>未发布</el-tag>
        </template>
        <template v-slot:dateTimeFrom="slotData">
          {{
            slotData.scope.row.dateTimeFrom &&
            slotData.scope.row.dateTimeFrom.slice(0, 10)
          }}
        </template>
        <template v-slot:isPublic="slotData">
          <el-tag size="small"
                  type="success"
                  v-if="slotData.scope.row.isPublic">是</el-tag>
          <el-tag size="small"
                  type="danger"
                  v-else>否</el-tag>
        </template>
        <template v-slot:dateTimeTo="slotData">
          {{
            slotData.scope.row.dateTimeTo &&
            slotData.scope.row.dateTimeTo.slice(0, 10)
          }}
        </template>
        <template v-slot:totalEnterprise="slotData">
          <div>
            {{
            slotData.scope.row.totalEnterprise|| 0
          }}
          </div>
        </template>
        <template v-slot:totalPosition="slotData">
          <div class="tableClick"
               @click="showDetail(slotData.scope.row,'职位数量')">
            {{
            slotData.scope.row.totalPosition|| 0
          }}
          </div>
        </template>
        <template v-slot:totalApply="slotData">
          <div class="tableClick"
               @click="showDetail(slotData.scope.row,'报名人数')">
            {{
            slotData.scope.row.totalApply || 0
          }}
          </div>

        </template>
        <template v-slot:sort="slotData">
          <el-input-number size="small"
                           :precision="0"
                           v-model="slotData.scope.row.sort"
                           controls-position="right"
                           @change="slotData.scope.row.add = '1'"></el-input-number>
        </template>

        <template v-slot:operation="slotData">
          <el-button @click="editCustomerInfo(slotData.scope.row,'pos')"
                     plain
                     size="small"
                     icon="el-icon-edit"
                     v-if="verifyPermission('Update')">编辑</el-button>
          <el-button @click="openDialog(slotData.scope.row)"
                     plain
                     type="primary"
                     size="small"
                     icon="el-icon-picture"
                     v-if="verifyPermission('Update')">小程序分享</el-button>
        </template>
      </MyTable>
      <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="getCustomerList"
                  ref="pagination" />
    </div>
    <el-dialog :title="batchNum == 1 ? '批量发布计划' : '批量公共计划'"
               :visible.sync="stateDialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               class="colleague-dialog"
               @close="resetForm">
      <el-form ref="form"
               :model="form"
               :inline="true"
               :rules="rules"
               label-width="auto"
               v-enterToNext="true">
        <el-col :span="24"
                v-if="batchNum == 1">
          <el-form-item label="计划生效"
                        prop="dateTimeFrom">
            <el-date-picker v-model="form.dateTimeFrom"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            :picker-options="startDatePickerOptions"
                            @change="handleDateChange"></el-date-picker>
          </el-form-item>

          <!-- 职位结束日期（限制：必须大于开始日期） -->
          <el-form-item label="计划结束">
            <el-date-picker v-model="form.dateTimeTo"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            :picker-options="endDatePickerOptions"
                            @change="handleDateChange"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24"
                v-if="batchNum == 2">
          <el-form-item label="公共计划"
                        prop="isPublic">
            <el-select v-model="form.isPublic"
                       placeholder="请选择">
              <el-option label="是"
                         :value="true">
              </el-option>
              <el-option label="否"
                         :value="false">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
              () => {
                resetForm();
                stateDialogVisible = false;
              }
            ">取 消</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="changeState('form')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="小程序码录入"
               :visible.sync="QRVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               center>
      <div style="display: flex; justify-content: center">
        <img :src="imgPath"
             alt=""
             v-if="$shareType == 2" />
        <div id="qrcode"
             ref="qrcode"
             v-if="$shareType == 1"></div>
      </div>
    </el-dialog>
    <QuantityDetails :drawerShow="qtyDtlsDrawerShow"
                     :title="qtyDtlsTitle"
                     @colseDrawer="qtyDtlsDrawerShow = false"
                     :customerInfo="QuantityDetails"></QuantityDetails>

    <ProjectAdd :drawerShow="ProjectAddDrawerShow"
                :title="drawerTitle"
                :operation="operation"
                :customerInfo="customerInfo"
                :industryData="industryData"
                @colseDrawer="ProjectAddDrawerShow = false"
                @refreshData="
        () => {
          getCustomerList();
        }
      " />

  </div>
</template>

<script>
import ProjectAdd from "./ProjectAdd";
import QuantityDetails from "./QuantityDetails";
import MyTable from "@/components/Table";
import Search from "@/components/Search";
import { verifyPermissionMinix, GetUnlimitedQRCodeMinix } from "@/utils/mixin";
export default {
  components: {
    Search,
    ProjectAdd,
    MyTable,
    QuantityDetails,
  },
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],
  data () {
    return {
      sortPara: {
        data: "",
        controller: "customer",
        action: "sort",
        callback: "getCustomerList",
      },
      tableName: "projectTable",
      qtyDtlsDrawerShow: false,
      tableConfig: [
        {
          field: "projectNumber",
          label: "计划批次号",
          flag: true,
          width: 180,
        },


        {
          field: "projectName",
          label: "计划名称",
          minWidth: 160,
          flag: true,
          align: "center",

        },
        {
          field: "totalRecruiting",
          label: "招聘数量",
          align: "center",
          flag: true,
        },
        {
          field: "totalEnterprise",
          label: "企业数量",
          align: "center",
          slotName: "totalEnterprise",
          flag: true,
        },
        {
          field: "totalPosition",
          label: "职位数量",
          align: "center",
          slotName: "totalPosition",
          flag: true,
        },

        {
          field: "totalApply",
          label: "报名人数",
          align: "center",
          slotName: "totalApply",
          width: 160,
          flag: true,
        },
        // {
        //   field: "projectStatus",
        //   label: "发布状态",
        //   minWidth: 30,
        //   align: "center",
        //   slotName: "isStop",
        //   flag: true,
        //   width: 100,
        // },
        {
          field: "isPublic",
          label: "公共计划",
          slotName: "isPublic",
          align: "center",
          width: 130,
          flag: true,
        },
        {
          field: "dateTimeFrom",
          label: "生效时间",
          slotName: "dateTimeFrom",
          width: 160,
          flag: true,
          align: "center",

        },
        {
          field: "dateTimeTo",
          label: "结束时间",
          slotName: "dateTimeTo",
          width: 160,
          align: "center",
          flag: true,
        },
        {
          label: "基本操作",
          slotName: "operation",
          width: 230,
          align: "center",
          fixed: "right",
          flag: true,
        },
      ],
      tabList: [],
      tabIndex: 0,
      aontractDrawerShow: false,
      ProjectAddDrawerShow: false,
      imageManageVisible: false,
      currentRow: null,
      drawerTitle: "",
      Ids: [],
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {},
      submitLoading: false,
      form: {

      },
      startDatePickerOptions: {
        disabledDate: (date) => {
          // 未选择结束日期时，不限制（可根据需求调整）
          if (!this.form.dateTimeTo) return false;

          // 转换结束日期为 Date 对象，清除时间部分
          const endDate = new Date(this.form.dateTimeTo);
          endDate.setHours(0, 0, 0, 0);

          // 禁用：结束日期及之后的所有日期（确保开始 < 结束）
          return date.getTime() >= endDate.getTime();
        }
      },
      // 结束日期选择器配置：禁用 <= 开始日期的日期
      endDatePickerOptions: {
        disabledDate: (date) => {
          // 未选择开始日期时，不限制（可根据需求调整）
          if (!this.form.dateTimeFrom) return false;

          // 转换开始日期为 Date 对象，清除时间部分
          const startDate = new Date(this.form.dateTimeFrom);
          startDate.setHours(0, 0, 0, 0);

          // 禁用：开始日期及之前的所有日期（确保结束 > 开始）
          return date.getTime() <= startDate.getTime();
        }
      },
      QuantityDetails: [],
      rules: {
        isPublic: [
          {
            required: true,
            message: "请选择是否公共计划",
            trigger: ["blur", "change"],
          },
        ],
        dateTimeFrom: [
          {
            required: true,
            message: "请选择生效期",
            trigger: ["blur", "change"],
          },
        ],
      },
      customerInfo: {},
      operation: "",
      companyId: "",
      batchNum: 1,
      industryData: [],
      delPara: {
        data: "",
        controller: "ProjectInfo",
        action: "Delete",
        callback: "getCustomerList",
      },
      qtyDtlsTitle: "",
      hidden: false,
      tableHeight: "",
      QRVisible: false,
      stateDialogVisible: false,
      imgPath: "",
      statusList: [
        {
          label: "已发布",
          value: "已发布",
        },
        {
          label: "未发布",
          value: "未发布",
        },
      ],
    };
  },
  computed: {},
  mounted () {
    this.getCustomerList();
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  methods: {
    handleDateChange () {
      const { dateTimeFrom, dateTimeTo } = this.form;
      // 两个日期都已选择时才校验
      if (dateTimeFrom && dateTimeTo) {
        const start = new Date(dateTimeFrom);
        const end = new Date(dateTimeTo);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        // 如果开始 >= 结束，清空后选择的那个日期（谁后变就清空谁）
        // 这里简化逻辑：直接清空结束日期（也可根据业务调整为清空开始日期）
        if (start >= end) {
          this.form.dateTimeTo = '';
          // 若想清空开始日期，可改为：this.form.dateTimeFrom = '';
        }
      }
    },
    //打开弹窗
    openDialog (row) {
      this.QRVisible = true;
      this.$nextTick(() => {
        this.qrcode(row.intId);
      });
    },
    //生成二维码
    qrcode (id) {
      let sendData = {
        page: "pages/packageC/position/job-project-list",
        check_path: false,
        width: 150,
        scene: "proId=" + id,
      };
      this.GetUnlimitedQRCode(sendData).then((res) => {
        this.imgPath = "data:image/png;base64," + res;
        this.submitLoading = false;
        this.QRVisible = true;
      });
    },
    // 批改状态
    batchState (num) {
      if (this.Ids.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.batchNum = num;
      this.stateDialogVisible = true;
    },
    //改变状态
    changeState (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.$confirm(`${this.batchNum == 1 ? '批量发布' : '批量公共计划'}`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
        }).then(() => {
          if (this.batchNum == 1) {
            let sendData = {
              idList: this.Ids,
              dateTimeFrom: this.form.dateTimeFrom,
              dateTimeTo: this.form.dateTimeTo,
            };
            this.submitLoading = true;
            this.$api.ProjectInfo.Release(sendData).then((res) => {
              if (res.error === false) {
                this.$message.success("更新成功");
                this.stateDialogVisible = false;
                this.getCustomerList();
              }
              this.submitLoading = false;
            });
          } else {
            let sendData = {
              idList: this.Ids,
              isPublic: this.form.isPublic,
            };
            this.submitLoading = true;
            this.$api.ProjectInfo.SetIsPublic(sendData).then((res) => {
              if (res.error === false) {
                this.$message.success("更新成功");
                this.stateDialogVisible = false;
                this.getCustomerList();
              }
              this.submitLoading = false;
            });
          }

        });
      });
    },
    //数量详情
    showDetail (row, name) {
      this.qtyDtlsTitle = name + '（' + row.projectName + '）';
      let sendData = {
        pageSize: -1,
        fkValue: row.id,
      };
      if (name == '职位数量') {
        this.$api.PositionInfo.ListProjectPosition(sendData).then((res) => {
          if (res.error === false) {
            this.QuantityDetails = res.data;
            this.qtyDtlsDrawerShow = true;
          }
        });
      } else if (name == '报名人数') {
        let sendData = {
          pageSize: -1,
          wheres: [
            {
              name: "projectId",
              value: row.id,
              expressionType: 'Equal',
            },
          ],
        };
        this.$api.JobApplicationInfo.List(sendData).then((res) => {
          if (res.error === false) {
            this.QuantityDetails = res.data;
            this.qtyDtlsDrawerShow = true;
          }
        });
      }

    },
    // 列的显示与隐藏
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    //多选
    selectionChange (selection) {
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
      this.Ids = selection.map((v) => {
        return v.id;
      });
    },
    //获取子组件高度
    getHeight (height) {
      this.tableHeight = height;
    },
    resetForm () {
      this.form = {};
      this.$refs.form.clearValidate();
    },
    clear () {
      console.log(0);
      this.searchForm.isCooperation = undefined;
    },
    //排序
    sortCustomer () {
      let arr = [];
      let obj = {};
      this.tableData.forEach((element) => {
        if (element.add == "1") {
          obj.id = element.id;
          obj.sort = element.sort ? element.sort : "";
          arr.push(obj);
          obj = {};
        }
      });
      this.$api.customer.sort(arr).then((res) => {
        if (res.error === false) {
          this.getCustomerList();
          this.$message.success("更新成功");
        }
      });
    },
    //获取数据
    getCustomerList () {
      this.loading = true;
      const sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        wheres: [
          {
            name: "keyword",
            value: this.searchForm.keyWord,
            expressionType: "Like",
          },
          {
            name: "isPublic",
            value: this.searchForm.isPublic != null ? String(this.searchForm.isPublic) : "",
            expressionType: "Equal",
          },
          {
            name: "dateTimeFrom",
            value: this.searchForm.dateTimeFrom,
            expressionType: "GreaterThanOrEqual",
          },
          {
            name: "dateTimeTo",
            value: this.searchForm.dateTimeTo,
            expressionType: "LessThanOrEqual",
          },

        ],
      };

      this.$api.ProjectInfo.PageData(sendData).then((res) => {
        if (res.error === false) {
          this.loading = false;

          this.tableData = res.data.data;
          this.sortPara.data = res.data.data;
          this.tableData.forEach((item) => {
            if (item.sort == null) {
              item.sort = undefined;
            }
          });
          this.total = res.data.count;
        }
      });
    },

    // 添加客户
    ProjectAdd () {
      this.operation = "add";
      this.ProjectAddDrawerShow = true;
      this.drawerTitle = "新增计划";
    },
    // 删除公司
    deleteCustomer (ids) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.posts.GetPositionByCid(ids).then((res) => {

            if (res.error === false) {
              this.$api.customer.deleteFactory(ids).then((res) => {
                if (res.error === false) {
                  this.getCustomerList();
                  this.$message.success("删除成功");
                }
              });

            }
          });
        })
        .catch(() => { });
    },
    getCustomerDetails (id) {
      return new Promise((resolve, reject) => {
        this.$api.ProjectInfo.Detail(id).then((res) => {
          if (res.error === false) {
            resolve(res.data);
          } else {
            reject("error");
          }
        });
      });
    },
    // 修改公司信息
    editCustomerInfo (row, flag) {
      this.getCustomerDetails({ id: row.id }).then((res) => {
        if (res) {
          this.operation = "edit";
          this.ProjectAddDrawerShow = true;
          this.drawerTitle = "修改计划信息";
          this.customerInfo = res;
        }
      });
    },


  },
};
</script>

<style lang="less">
// .el-form-item__label {
//   width: 60px !important;
// }
.top-buttons {
  transition: 1s;
}

.el-dropdown-link {
  margin-right: 10px;
}
.btn {
  margin-left: 15px;
}
.customer-list {
  .category {
    width: 200px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-right: 20px;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 15px;
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
    li {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: var(--theme-black);
        text-decoration: underline;
      }
    }
    .tab-active {
      color: #87481f !important;
      text-decoration: underline !important;
    }
  }
  .customer-table-list {
    width: calc(100%);
    height: calc(100vh - 140px);
  }
}
</style>
